import React from "react";
import { Link } from "react-router-dom";

const TestSeriesManager = () => {
  const linkStyle =
    "block p-6 rounded-xl shadow-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 text-center font-semibold transition hover:shadow-lg hover:bg-blue-100 dark:hover:bg-blue-900";

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h2 className="text-3xl font-bold mb-8 text-gray-900 dark:text-gray-100">
        🏆 Test Series Manager
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <Link to="/admin/test-series/prelims/upload" className={linkStyle}>
          Upload Prelims Test
        </Link>

        <Link to="/admin/test-series/prelims/view" className={linkStyle}>
          View / Delete Prelims Tests
        </Link>

        <Link to="/admin/test-series/mains/upload" className={linkStyle}>
          Upload Mains Test
        </Link>

        <Link to="/admin/test-series/mains/view" className={linkStyle}>
          View / Delete Mains Tests
        </Link>

        <Link to="/admin/test-series/mains/review" className={linkStyle}>
          Review Mains Submissions
        </Link>
      </div>
    </div>
  );
};

export default TestSeriesManager;
